import styled from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

export const Popover = styled.div`
  position: fixed;
  z-index: 60;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 320px;
  padding: 16px;
  border-radius: ${radius.lg};
  font-family: ${font.text};
  color: ${colors.ink};
  background: ${colors.surface};
  box-shadow: ${shadow.raised};
  transform: translateX(-50%);
`;

export const Close = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: ${colors.muted};
  background: ${colors.bg};
  cursor: pointer;
`;

export const Word = styled.p`
  padding-right: 30px;
  font-size: 20px;
  font-weight: 800;
`;

export const Translation = styled.input`
  padding: 10px 12px;
  border-radius: ${radius.sm};
  border: 1.5px solid ${colors.line};
  font-family: ${font.text};
  font-size: 18px;
  font-weight: 700;
  color: ${colors.brandDeep};
  background: ${colors.brandSoft};
  outline: none;

  &:focus {
    border-color: ${colors.brand};
  }
`;

export const Select = styled.select`
  padding: 9px 10px;
  border-radius: ${radius.sm};
  border: 1.5px solid ${colors.line};
  font-family: ${font.text};
  font-size: 15px;
  background: ${colors.surface};
`;

export const Add = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 12px;
  border-radius: ${radius.sm};
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 800;
  color: #FFFFFF;
  background: ${(props) => (props.$saved ? colors.success : colors.brand)};
  cursor: pointer;

  &:disabled {
    opacity: ${(props) => (props.$saved ? 1 : 0.5)};
    cursor: default;
  }
`;

export const Error = styled.p`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.danger};
`;
